@if (visible()) {
  <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
  <div class="tho-backdrop" (click)="cancel()">
    <div
      class="tho-dialog"
      role="dialog"
      aria-modal="true"
      aria-labelledby="tho-title"
      data-testid="testrun-handover-modal"
      cdkTrapFocus
      [cdkTrapFocusAutoCapture]="true"
      (click)="$event.stopPropagation()"
      (keydown.escape)="cancel()"
    >
      <to-section-title headingId="tho-title" [title]="'testRunner.handover.title' | translate" [subtitle]="subtitle()">
        <button
          right
          type="button"
          class="tho__close"
          data-testid="testrun-handover-close"
          [attr.aria-label]="'testRunner.handover.cancel' | translate"
          [disabled]="submitting()"
          (click)="cancel()"
        >
          <mat-icon aria-hidden="true">close</mat-icon>
        </button>
      </to-section-title>

      <div class="tho__body">
        <h3 class="tho__legend" id="tho-people-label">{{ 'testRunner.handover.personLabel' | translate }}</h3>
        @if (people().length === 0) {
          <p class="tho__empty" data-testid="testrun-handover-people-empty">
            {{ 'testRunner.handover.noPeople' | translate }}
          </p>
        } @else {
          <div class="tho__people" role="group" aria-labelledby="tho-people-label">
            @for (person of people(); track person.id) {
              <button
                type="button"
                class="tho__person"
                data-testid="testrun-handover-person"
                [class.tho__person--on]="selectedPersonId() === person.id"
                [attr.aria-pressed]="selectedPersonId() === person.id"
                [disabled]="submitting()"
                (click)="selectPerson(person.id)"
              >
                <app-avatar [name]="person.displayName" [size]="26" />
                <span class="tho__person-name">{{ person.displayName }}</span>
                @if (selectedPersonId() === person.id) {
                  <mat-icon class="tho__check" aria-hidden="true">check</mat-icon>
                }
              </button>
            }
          </div>
        }

        <h3 class="tho__legend" id="tho-groups-label">{{ 'testRunner.handover.groupLabel' | translate }}</h3>
        <div class="tho__groups" role="group" aria-labelledby="tho-groups-label">
          @for (group of groups(); track group) {
            <button
              type="button"
              class="tho__group"
              data-testid="testrun-handover-group"
              [class.tho__group--on]="selectedGroup() === group"
              [attr.aria-pressed]="selectedGroup() === group"
              [disabled]="submitting()"
              (click)="toggleGroup(group)"
            >
              {{ group }}
            </button>
          }
        </div>

        <label class="tho__legend" for="tho-note">{{ 'testRunner.handover.noteLabel' | translate }}</label>
        <textarea
          #noteField
          id="tho-note"
          class="tho__note"
          rows="2"
          data-testid="testrun-handover-note"
          [attr.maxlength]="fieldLengths.FREETEXT_MAX"
          [attr.placeholder]="'testRunner.handover.notePlaceholder' | translate"
          [disabled]="submitting()"
          [value]="note()"
          (input)="note.set(noteField.value)"
        ></textarea>
        <p class="tho__counter" aria-live="polite">{{ note().length }} / {{ fieldLengths.FREETEXT_MAX }}</p>
      </div>

      <div class="tho__actions">
        <button
          type="button"
          class="tho__btn tho__btn--ghost"
          data-testid="testrun-handover-cancel"
          [disabled]="submitting()"
          (click)="cancel()"
        >
          {{ 'testRunner.handover.cancel' | translate }}
        </button>
        <button
          type="button"
          class="tho__btn tho__btn--primary"
          data-testid="testrun-handover-submit"
          [disabled]="!canSubmit()"
          (click)="submit()"
        >
          @if (submitting()) {
            <mat-spinner diameter="16" />
          } @else {
            <mat-icon aria-hidden="true">pause</mat-icon>
          }
          {{ 'testRunner.handover.submit' | translate }}
        </button>
      </div>
    </div>
  </div>
}
